module.exports = __webpack_public_path__ + "static/testimonials-62de7d724c7475d8440356d1989a67e0.png";